import { useCallback, useState } from 'react';

import productService from 'v2/services/product';

export const useValidateProductTitle = () => {
  const [productTitleExists, setProductTitleExists] = useState(false);

  const validateTitle = useCallback(async (title: string) => {
    try {
      const response = await productService.listMyProducts({ exact_title: title }, { current_page: 1, per_page: 1 });
      setProductTitleExists((response?.data?.length ?? 0) > 0);
    } catch {
      // preserve existing behavior: silently ignore validation errors
    }
  }, []);

  return { productTitleExists, validateTitle };
};
